import { render, staticRenderFns } from "./u-card.vue?vue&type=template&id=80bc29b2&scoped=true&"
import script from "./u-card.vue?vue&type=script&lang=js&"
export * from "./u-card.vue?vue&type=script&lang=js&"
import style0 from "./u-card.vue?vue&type=style&index=0&id=80bc29b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bc29b2",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-card/u-card.vue"
export default component.exports